import React from "react";
import { CheckCircle2, AlertTriangle, BellRing } from "lucide-react";

export function InvoiceStatusBadge({ invoiceRef, testid }) {
  if (invoiceRef && invoiceRef.trim() !== "") {
    return (
      <span data-testid={testid || "invoice-status-badge"} className="badge-invoiced">
        <CheckCircle2 className="w-3.5 h-3.5" strokeWidth={2.5} />
        Invoiced
      </span>
    );
  }
  return (
    <span data-testid={testid || "invoice-status-badge"} className="badge-outstanding">
      <AlertTriangle className="w-3.5 h-3.5" strokeWidth={2.5} />
      Outstanding
    </span>
  );
}

export function RepeatBadge({ repeat }) {
  const label = repeat === "monthly" ? "Monthly"
    : repeat === "annual" ? "Annual"
    : repeat === "custom" ? "Custom"
    : "Once-off";
  return <span className="badge-info">{label}</span>;
}

export function RenewalBadge({ daysUntil }) {
  if (daysUntil <= 7) {
    return (
      <span className="badge-danger">
        <BellRing className="w-3.5 h-3.5" strokeWidth={2.5} />
        {daysUntil <= 0 ? "Due now" : `${daysUntil}d`}
      </span>
    );
  }
  return (
    <span className="badge-outstanding">
      <BellRing className="w-3.5 h-3.5" strokeWidth={2.5} />
      {daysUntil}d
    </span>
  );
}
